// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.element {
  padding: 20px 0;
  padding-left: 10px;
  padding-right: 10px;
  transition: all 0.2s ease-in;
  border-bottom: 1px solid #e5e5e5;
}
.element:hover {
  background-color: #d8f1ff;
}
.element .file-desc-content .name {
  font-size: 1.1em;
  margin-bottom: 10px;
  color: #2a5298;
}
.element .file-desc-content .name:hover {
  text-decoration: underline;
}
.element .file-desc-content .dateModify {
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.9em;
  font-style: italic;
}
.element .file-desc-content .weight {
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.9em;
}
.element .file-desc-content .description {
  color: rgba(0, 0, 0, 0.54);
}
.element .file-desc-content .location {
  color: rgba(0, 0, 0, 0.54);
}`, "",{"version":3,"sources":["webpack://./src/app/+home/search/shared/components/display-search-results/display-search-results.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EAIA,4BAAA;EACA,gCAAA;AACF;AACE;EACE,yBAAA;AACJ;AAMI;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AAJN;AAMM;EACE,0BAAA;AAJR;AAQI;EACE,0BAAA;EACA,gBAAA;EACA,kBAAA;AANN;AASI;EACE,0BAAA;EACA,gBAAA;AAPN;AAUI;EACE,0BAAA;AARN;AAWI;EACE,0BAAA;AATN","sourcesContent":[".element {\r\n  padding: 20px 0;\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n  -moz-transition: all 0.2s ease-in;\r\n  -o-transition: all 0.2s ease-in;\r\n  -webkit-transition: all 0.2s ease-in;\r\n  transition: all 0.2s ease-in;\r\n  border-bottom: 1px solid #e5e5e5;\r\n\r\n  &:hover {\r\n    background-color: #d8f1ff;\r\n  }\r\n\r\n  .icon {\r\n  }\r\n\r\n  .file-desc-content {\r\n    .name {\r\n      font-size: 1.1em;\r\n      margin-bottom: 10px;\r\n      color: #2a5298;\r\n\r\n      &:hover {\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n\r\n    .dateModify {\r\n      color: rgba(0, 0, 0, 0.54);\r\n      font-size: 0.9em;\r\n      font-style: italic;\r\n    }\r\n\r\n    .weight {\r\n      color: rgba(0, 0, 0, 0.54);\r\n      font-size: 0.9em;\r\n    }\r\n\r\n    .description {\r\n      color: rgba(0, 0, 0, 0.54);\r\n    }\r\n\r\n    .location {\r\n      color: rgba(0, 0, 0, 0.54);\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
